import './styles.scss'
import I18n from 'lib/i18n'

import React from 'react'
import { useActions, useValues } from 'kea'
import Close from 'lib/icons/close'

import filtersLogic from '~/scenes/search/filters-page/logic'
import searchLogic from '~/scenes/search/logic'
import PropTypes from 'prop-types'

export default function TopActions ({ activeSubMenu, locationTopActionsStyles }) {
  const { clearFilter } = useActions(filtersLogic)
  const { receiveResults } = useActions(searchLogic)
  const { results, filter } = useValues(searchLogic)

  const handleClick = () => {
    const {
      helmet,
      helmet: { meta }
    } = results
    // cancel prevent automatic zoom for iphone previously added
    const metaArray = meta.filter(metaTag => metaTag.name !== 'viewport')
    receiveResults(
      {
        ...results,
        helmet: {
          ...helmet,
          meta: [...metaArray, { name: 'viewport', content: 'width=device-width, initial-scale=1' }]
        }
      },
      filter
    )
    window.history.back()
  }

  return (
    <div className={`all-filters-top-actions ${locationTopActionsStyles ? 'no-border' : ''}`}>
      <Close onClick={handleClick} style={{ background: '#fff' }} pathStyle={{ stroke: '#222' }} />
      <div onClick={() => clearFilter(activeSubMenu)} className='clear-all'>
        {I18n.t('react.search.filters.clear_all_button')}
      </div>
    </div>
  )
}

TopActions.propTypes = {
  locationTopActionsStyles: PropTypes.bool,
  activeSubMenu: PropTypes.string
}
